import action from './action';
import {createActionType, createRequestTypes} from './actionTypes';

export const requestActionsFor = (resourceName) => {
    if (resourceName == null) throw new Error('requestActionsFor: Expected resourceName');
    resourceName = resourceName.toUpperCase();

    const actionTypes = createRequestTypes(resourceName);

    let actionCreators = {
        success : (payload) => action(actionTypes.SUCCESS)(payload),
        error   : (payload) => action(actionTypes.ERROR)(payload)
    };

    return {
        request : (payload) => action(actionTypes.REQUEST)({request: resourceName, actions:{...actionCreators}, ...payload}),
        ...actionCreators
    };
};

export const simpleActionFor = (actionType, resourceName) => {
    if (actionType == null) throw new Error('simpleActionFor: Expected resourceName');

    return (payload) => action(actionType || createActionType(resourceName))(payload);
};
